import { matchRoutes } from "react-router-dom";
import type { PrivatePageTelemetry } from "./sentry-private-page";

export const PREFERENCE_OPENED = "Communication preferences page opened";
export const PREFERENCE_SAVED = "Communication preferences saved";

// Register private routes here before exposing them in App. Policies must contain
// static names only, never URL parameters or guest data.
export const communicationPreferencesPage = {
  path: "/communication-preferences",
  errorMessage: "Communication preferences page error",
  events: [PREFERENCE_OPENED, PREFERENCE_SAVED],
  timings: [
    { name: "communication-preferences.open", op: "ui.load" },
    { name: "communication-preferences.read", op: "http.client" },
    { name: "communication-preferences.save", op: "http.client" },
  ],
} satisfies PrivatePageTelemetry & { path: string };

export const privatePages = [communicationPreferencesPage];

export const getPrivatePage = (pathname: string) => privatePages.find((page) =>
  matchRoutes([{ path: page.path, caseSensitive: false }], pathname) !== null,
);

export const OFFER_PREVIEW_ID_PARAM = "previewOfferAdId";
export const OFFER_PREVIEW_TOKEN_PARAM = "offerPreviewToken";

// The preview opens on an ordinary landing route, so it is private for telemetry only.
export const offerAdPreviewPage = {
  errorMessage: "Offer ad preview error",
  events: [],
  timings: [],
} satisfies PrivatePageTelemetry;

type TelemetryLocation = { pathname: string; search: string; hash: string };

export const getPrivateTelemetry = ({ pathname, search, hash }: TelemetryLocation): PrivatePageTelemetry | undefined =>
  getPrivatePage(pathname) ??
  (new URLSearchParams(search).has(OFFER_PREVIEW_ID_PARAM) ||
    new URLSearchParams(hash.slice(1)).has(OFFER_PREVIEW_TOKEN_PARAM)
    ? offerAdPreviewPage
    : undefined);
